import { Fetch } from '../fetch/fetch-service';

export function fetchUsers() {
  return Fetch('/idp-auth/pbasen/admin/Users');
}

export function fetchSingleUser(id) {
  return Fetch(`/idp-auth/admin/Users?id=${id}`);
}

export function putUser(user = {}) {
  return Fetch('/idp-auth/pbasen/admin/User', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  });
}

export function postEditUser(guid, user = {}) {
  return Fetch(`/idp-auth/pbasen/admin/User?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  });
}

export function fetchUser(guid) {
  return Fetch(`/idp-auth/pbasen/admin/User?id=${guid}`);
}

export function postActivateUser(guid, activation) {
  const jsonbody = JSON.stringify({
    active: activation,
  });
  return Fetch(`/idp-auth/pbasen/admin/User?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonbody,
  });
}

export function postRemoveUser(guid) {
  return Fetch(`/idp-auth/pbasen/admin/RemoveUser?id=${guid}`, {
    method: 'POST',
    headers: {},
  });
}

export function fetchHistoryUser(id) {
  return Fetch(`/idp-auth/pbasen/admin/UserHistory?id=${id}`);
}
